import { colors } from "@toddle-edu/ds-theme";

export const plusButtonStyle = { color: colors.neutral300, cursor: "pointer" };

export const addTagButtonStyle = {
  width: "fit-content",
  height: "20px",
  borderRadius: "12px",
  padding: "4px 8px",
  minWidth: "36px",
  marginLeft: "auto",
};

export const addTagLabelStyle = { fontSize: "1rem" };
